import React, {Component} from 'react';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import UOMsList from './UOMsList';
import UOMDataService from "./services/uom.service";
import * as FaIcons from "react-icons/fa";
import { Button, Container, FormControl, FormLabel } from 'react-bootstrap';

var newDate = new Date()
var gtDate = newDate.getDate().toString().padStart(2,'0') + '-' + (newDate.getMonth()+1).toString().padStart(2,'0') + '-' + newDate.getFullYear()

class UOMs extends Component {

  constructor(props) {
    super(props);
    this.onChangeUOMFilterByDescr = this.onChangeUOMFilterByDescr.bind(this);
    this.onChangeSortField = this.onChangeSortField.bind(this);
    this.onChangeSortType = this.onChangeSortType.bind(this);
    this.performSearch = this.performSearch.bind(this);

    this.state = {
      listOfUOMs: null,
      UOMFilterByDescr: '',
      SortField: 'id',
      SortType: 'ASC'
    };
  }  

  onChangeSortType() {
    this.setState({
      SortType: (this.state.SortType == 'DESC')?'ASC':'DESC'
    });
    this.performSearch(this.state.UOMFilterByDescr,this.state.SortField,this.state.SortType);    
  }

  onChangeSortField(e) {
    this.setState({
      SortField: e.target.value
    });
    this.performSearch(this.state.UOMFilterByDescr,e.target.value,this.state.SortType);
  }

  onChangeUOMFilterByDescr(e) {
    this.setState({
      UOMFilterByDescr: e.target.value
    });
    this.performSearch(e.target.value,this.state.SortField,this.state.SortType);
  }

  componentDidMount() {
    this.performSearch(this.state.UOMFilterByDescr, this.state.SortField,this.state.SortType);  
  }

  performSearch = (descr,sortfield,sorttype) => {
    UOMDataService.getUOMByDescr(descr,sortfield,sorttype)
      .then(response => {
        console.log(response.data);
        this.setState({
          listOfUOMs: response.data
        });
        console.log(this.state.listOfUOMs);
      })
      .catch(e => {
        console.log(e);
      });
  };

  searchWithEnter = (event)=> {
    if (event.keyCode === 13) {
      this.performSearch();
    }
  }  

  render (){
    return (
      <>
      <Container style={{width:"80%"}}>
        <Row className='mb-2 d-flex'>
          <FormLabel style={{fontSize:"0.8em",textAlign:"right"}}>Current Date: {gtDate}</FormLabel>
          <hr/>
          <h4 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Units of Measure</h4>
          <Col lg={true}>
            <FormLabel className='mb-2'>Filter By UOM Abbreviation:</FormLabel>       
            <FormControl type="text" name="filterbyUOMabbreviation" id="filterbyUOMabbreviation" onChange={this.onChangeUOMFilterByDescr}></FormControl>
          </Col>
          <Col lg={true}>
            <FormLabel className='mb-2'>Sort By:</FormLabel>       
              <FormControl as='select' onChange={this.onChangeSortField}>
                <option value="id">UOM ID</option>
                <option value="unitofmeasureabbrev">UOM Abbreviation</option>
              </FormControl>
          </Col>
          
          <Col sm={true}>
            <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
            <FormControl style={{maxWidth:"50px"}} as="button" onClick={this.onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
          </Col>          
        </Row>
        <Link to="/new-uom" className="mr-2 btn btn-primary">New UOM</Link>            
        <Button className="m-2 btn btn-primary">Export</Button>        
        <Row>
          <UOMsList listOfUOMs = {this.state.listOfUOMs} />      
        </Row>
      </Container>
      </>
    )
  }
}

export default UOMs;